//CHECKS Listing
export const FETCH_CRYPTO_LISTING_SUCCESS = 'FETCH_CRYPTO_LISTING_SUCCESS';
export const FETCH_CRYPTO_LISTING_FAILURE = 'FETCH_CRYPTO_LISTING_FAILURE';

export const RESET = 'RESET';
